// @ts-strict-ignore
import {DEFAULT_PEOPLE_PROPERTY_OPTIONS} from '../constants';
import {OperatorNode} from '../expression/operator-node';
import {SerializedPropertyFilter} from '../types/serialized-staged-cohort-types';
import {Clause} from './clause';
import {PropertyFilter} from './property-filter';

interface PeoplePropertyClauseOptions {
  propertyFilters: [PropertyFilter];
}

export class PeoplePropertyClause extends Clause {
  public static createDefault(): PeoplePropertyClause {
    return new PeoplePropertyClause({
      propertyFilters: [new PropertyFilter(DEFAULT_PEOPLE_PROPERTY_OPTIONS)],
    });
  }

  public static deserialize(options: SerializedPropertyFilter): PeoplePropertyClause {
    return new PeoplePropertyClause({propertyFilters: [PropertyFilter.deserialize(options)]});
  }

  public static createFromParts(parts: {tree: OperatorNode}): PeoplePropertyClause {
    return new PeoplePropertyClause({
      propertyFilters: [PropertyFilter.createFromParts(parts)],
    });
  }

  constructor(options: PeoplePropertyClauseOptions) {
    super(options);
  }

  public get propertyFilter() {
    return this.getPropertyFilters()[0];
  }

  public serialize(): SerializedPropertyFilter {
    return this.propertyFilter.serialize();
  }

  public isNegated(): boolean {
    return this.propertyFilter.negated;
  }

  public setNegated(negated: boolean): PeoplePropertyClause {
    if (this.isNegated() === negated) {
      return this;
    }

    return this.newClause({propertyFilters: [this.propertyFilter.setNegated(negated)]});
  }

  public getExpressionTree(): OperatorNode {
    return this.propertyFilter.getExpressionTree();
  }

  public toTrackingData(): Obj {
    return {
      ...{negated: this.isNegated()},
      ...this.propertyFilter.toTrackingData(),
    };
  }

  public isInvalidForDataGroup({dataGroupId}): boolean {
    return this.getPropertyFilters().some((pf) => pf.isInvalidForDataGroup(dataGroupId));
  }

  protected newClause(options: Partial<PeoplePropertyClauseOptions> = {}): PeoplePropertyClause {
    const oldOptions: PeoplePropertyClauseOptions = {propertyFilters: [this.getPropertyFilters()[0]]};
    return new PeoplePropertyClause({...oldOptions, ...options});
  }
}
